'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
// If intl is not supported by the browser, we manually import the intl polyfill and locale data
var IntlSafariPolyfill = function IntlSafariPolyfill(renderApp) {
    if (!window.Intl) {
        require.ensure(['intl', 'intl/locale-data/jsonp/en.js', 'intl/locale-data/jsonp/de.js', 'intl/locale-data/jsonp/fr.js'], function (require) {
            require('intl');
            require('intl/locale-data/jsonp/en.js');
            require('intl/locale-data/jsonp/de.js');
            require('intl/locale-data/jsonp/fr.js');
            renderApp();
        }, 'IntlPolyfill');
    } else {
        renderApp();
    }
};

exports.default = IntlSafariPolyfill;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./app/utils/IntlSafariPolyfill.js
// module id = 1424
// module chunks = 0